/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCloudMobile = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M15 4a4.974 4.974 0 0 0-4.643 3.194A4.84 4.84 0 0 0 9 7a5 5 0 0 0-5 5v.491c-1.465 1.157-2.207 2.717-2.583 3.972a10.325 10.325 0 0 0-.41 2.31 5.91 5.91 0 0 0-.007.204V20h5v-2H3.107c.049-.285.121-.613.226-.963.337-1.124.986-2.381 2.222-3.205L6 13.535V12a3 3 0 0 1 3-3c.55 0 1.068.16 1.528.436l1.343.804.165-1.556A2.988 2.988 0 0 1 15 6a3 3 0 0 1 3 3c0 .005 0 .023-.007.076l-.007.05-.006.044-.015.133-.071.729.673.288A4 4 0 0 1 21 14c0 .95-.402 1.987-1.034 2.786C19.318 17.606 18.576 18 18 18v2c1.423 0 2.682-.896 3.534-1.972C22.401 16.931 23 15.467 23 14a5.995 5.995 0 0 0-3.004-5.198A5 5 0 0 0 15 4z" />
        <path d="M8 11h8v11H8zm2 2v7h4v-7z" />
        <path d="M11 18h2v1h-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgCloudMobile as CloudMobile };
